var _rect, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountlimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#F59638"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14062 7.92969V13.2422",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 9.6875L9.14062 7.92969L7.38281 9.6875",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8594 7.92969V13.2422",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6172 9.6875L20.8594 7.92969L19.1016 9.6875",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_14230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 20,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H25V25H5V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_14230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.82812V10.8984",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 7.58594L15 5.82812L13.2422 7.58594",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5715 16.95H13.0515V18.302H13.5845C13.8358 18.302 14.0438 18.2521 14.2085 18.1525C14.3732 18.0485 14.4555 17.8795 14.4555 17.6455C14.4555 17.3985 14.3775 17.2208 14.2215 17.1125C14.0655 17.0041 13.8488 16.95 13.5715 16.95ZM14.7805 20.668L13.8445 18.978C13.7968 18.9823 13.747 18.9866 13.695 18.991C13.643 18.991 13.591 18.991 13.539 18.991H13.0515V20.668H12.213V16.248H13.5975C14.0785 16.248 14.4902 16.3585 14.8325 16.5795C15.1748 16.8005 15.346 17.1428 15.346 17.6065C15.346 17.8795 15.2745 18.1156 15.1315 18.315C14.9928 18.51 14.813 18.6616 14.592 18.77L15.6775 20.668H14.7805ZM17.9977 18.367C17.846 18.2976 17.7052 18.2456 17.5752 18.211C17.4452 18.172 17.3065 18.1525 17.1592 18.1525C17.0509 18.1525 16.9664 18.1741 16.9057 18.2175C16.8494 18.2565 16.8212 18.3128 16.8212 18.3865C16.8212 18.4385 16.8559 18.4883 16.9252 18.536C16.9989 18.5836 17.1159 18.6356 17.2762 18.692C17.5405 18.7873 17.7854 18.9216 18.0107 19.095C18.236 19.264 18.3487 19.485 18.3487 19.758C18.3487 20.07 18.236 20.3126 18.0107 20.486C17.7897 20.6593 17.4647 20.746 17.0357 20.746C16.9014 20.746 16.7215 20.72 16.4962 20.668C16.2752 20.616 16.091 20.5336 15.9437 20.421L16.1972 19.81C16.3489 19.8793 16.494 19.9335 16.6327 19.9725C16.7757 20.0071 16.9057 20.0245 17.0227 20.0245C17.1787 20.0245 17.2979 20.0028 17.3802 19.9595C17.4625 19.9161 17.5037 19.8598 17.5037 19.7905C17.5037 19.7038 17.4625 19.6258 17.3802 19.5565C17.2979 19.4871 17.1679 19.4243 16.9902 19.368C16.7389 19.2856 16.5005 19.1686 16.2752 19.017C16.0542 18.861 15.9437 18.653 15.9437 18.393C15.9437 18.094 16.0542 17.86 16.2752 17.691C16.4962 17.5176 16.7952 17.431 17.1722 17.431C17.3065 17.431 17.4799 17.4591 17.6922 17.5155C17.9045 17.5718 18.0909 17.6541 18.2512 17.7625L17.9977 18.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24.4141C11.7693 24.4141 9.14062 21.7463 9.14062 18.5156C9.14062 15.285 11.7693 12.6563 15 12.6563C18.2307 12.6563 20.8594 15.285 20.8594 18.5156C20.8594 21.7463 18.2307 24.4141 15 24.4141Z",
    stroke: "white",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountlimit);
export default __webpack_public_path__ + "static/media/accountlimit.3c79429b921625a88bdfbbffc70419af.svg";
export { ForwardRef as ReactComponent };